import _app from "../apps/money_order/ticketHistory";

let formatNumber = function(num) {
  if (num != null){
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 ");
  }
  return ""
};

let formatShortText = function(text) {
  if (text.length > 20 ){
    return text.slice(0, 20) + '...';
  }
  else
    return text;

};

let formatDate = function(date) {
  if (date) {
    return new Date(Date.parse(date)).toLocaleDateString();
  }
  return "";
};

let formatDateTime = function(datetime) {
  if (datetime) {
    let datetimeInst = new Date(Date.parse(datetime));
    return (
      datetimeInst.toLocaleDateString() +
      " " +
      datetimeInst.toLocaleTimeString()
    );
  }
  return "";
};

let formatErrorMsg = function(code, msg) {
  return msg + "(#" + code + ") ";
};

let format400FieldError = function(data) {
  let count = 0;
  let error_str = "";
  for (let field in data) {
    if (this.isObject(data[field])) {
      for (let field2 in data[field]) {
        // console.log(data[field]);
        if (count === 0)
          error_str =
            this.schema[field2].label + ": " + data[field][field2].join(". ");
        else
          error_str +=
            "<br>" +
            this.schema[field2].label +
            ": " +
            data[field][field2].join(". ");
      }
    } else {
      if (count === 0)
        error_str = this.schema[field].label + ": " + data[field].join(". ");
      else
        error_str +=
          "<br>" + this.schema[field].label + ": " + data[field].join(". ");
    }

    count++;
  }
  return error_str;
};

let arrayError = function(data) {
  data = JSON.stringify(data);
  return data
};

let formatHttpError = function(status, data) {
  let message = "Ошибка";
  if (status === 400) {
    if (data && "message" in data && data.message !== 'There are opened shifts') {
      message = data.message;
    }
    else if (data && "userMessage" in data) {
      message = data.userMessage[0].text;
    }
    else {
      // message = arrayError(data);
      message = format400FieldError(data);
    }
  }
  // else if (status === 403) {
  //   message = "Нет прав на выполнение операции.";
  //   if ("message" in data) {
  //     message = data.message;
  //   }
  // }
  else if (status === 404) {
    message = "Объект не найден";
    if (data && "message" in data && data.message !== 'LK: Not found.') {
      message = data.message;
    }
     else if(data && "code" in data && "message" in data) {
      message = null;
    }
  }

  else if (status === 409) {
    message = "Произошла ошибка. Обратитесь в службу поддержки";
  if (data && "userMessage" in data) {
      message = data.userMessage[0].text;
    }
  }

  else if (status === 500) {
     message = "Ошибка сервера";
    if (data && "message" in data) {
      message = data.message;
    }
  } else {
    message =
      "Произошла неизвестная ошибка. Обратитесь в службу технической поддержки.";
  }
  return message;
};

function b64DecodeUnicode (str) {
  // Going backwards: from bytestream, to percent-encoding, to original string.
  return decodeURIComponent(
    atob(str)
      .split("")
      .map(function(c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );
};


export {
  formatNumber,
  formatShortText,
  formatDate,
  formatDateTime,
  formatErrorMsg,
  formatHttpError,
  b64DecodeUnicode
};



// WEBPACK FOOTER //
// ./src/base/base_func.js